export default __webpack_public_path__ + "static/media/schoolBuilding.f0a64562.png";